import styled from 'styled-components';

// Main Footer Wrapper
export const FooterWrapper = styled.footer`
  background-color: #f9f8f4;
  color: #1a1a18;
  width: 100%;
  margin-top: auto;
  border-top: 1px solid #eeedea;
`;

// Container with max-width and responsive padding
export const FooterContainer = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  padding: 0 24px;

  @media (max-width: 768px) {
    padding: 0 16px;
  }
`;

// Main footer content area
export const FooterMain = styled.div`
  padding: 64px 0 48px;

  @media (max-width: 768px) {
    padding: 48px 0 32px;
  }
`;

// Newsletter Section
export const NewsletterSection = styled.section`
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  max-width: 600px;
  margin: 0 auto;
  gap: 32px;

  @media (max-width: 768px) {
    max-width: 100%;
    gap: 24px;
    padding: 0 8px;
  }

  @media (max-width: 480px) {
    gap: 20px;
    padding: 0 4px;
  }
`;

export const NewsletterContent = styled.div`
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const NewsletterTitle = styled.h2`
  font-family: 'Playfair Display', Georgia, serif;
  font-size: 36px;
  font-weight: 500;
  line-height: 1.2;
  letter-spacing: -0.02em;
  margin: 0;
  color: #1a1a18;

  @media (max-width: 1024px) {
    font-size: 32px;
  }

  @media (max-width: 768px) {
    font-size: 28px;
    line-height: 1.3;
  }

  @media (max-width: 480px) {
    font-size: 24px;
  }
`;

export const NewsletterDescription = styled.p`
  font-family: 'DM Sans', system-ui, sans-serif;
  font-size: 18px;
  font-weight: 400;
  line-height: 1.5;
  margin: 0;
  color: #4a4a42;

  @media (max-width: 768px) {
    font-size: 16px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

// Newsletter Form
export const NewsletterForm = styled.form`
  display: flex;
  flex-direction: column;
  gap: 16px;
  width: 100%;
  max-width: 500px;

  @media (max-width: 768px) {
    max-width: 100%;
  }
`;

export const EmailInputWrapper = styled.div`
  display: flex;
  gap: 12px;
  width: 100%;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 16px;
  }
`;

export const EmailInput = styled.input`
  flex: 1;
  height: 56px;
  padding: 0 20px;
  border: 1px solid #e6e5de;
  border-radius: 28px;
  background-color: #ffffff;
  color: #1a1a18;
  font-family: 'DM Sans', system-ui, sans-serif;
  font-size: 16px;
  font-weight: 400;
  outline: none;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.04);
  width: 100%;
  min-width: 0;

  &::placeholder {
    color: #8a8a80;
    opacity: 0.9;
  }

  &:focus {
    border-color: #e8854a;
    box-shadow: 0 4px 20px rgba(232, 133, 74, 0.18);
    transform: translateY(-1px);
  }

  &:invalid:not(:placeholder-shown) {
    border-color: #ff6b6b;
  }

  @media (max-width: 768px) {
    flex: none;
    width: 100%;
    height: 52px;
    border-radius: 26px;
  }

  @media (max-width: 480px) {
    height: 50px;
    border-radius: 25px;
    padding: 0 18px;
    font-size: 16px; /* Prevents zoom on iOS */
  }
`;

export const SubmitButton = styled.button`
  height: 56px;
  padding: 0 32px;
  border: none;
  border-radius: 28px;
  background-color: #e8854a;
  color: #ffffff;
  font-family: 'DM Sans', system-ui, sans-serif;
  font-size: 16px;
  font-weight: 600;
  cursor: pointer;
  white-space: nowrap;
  transition: all 0.3s ease;
  box-shadow: 0 4px 20px rgba(232, 133, 74, 0.35);
  min-width: 120px;

  &:hover:not(:disabled) {
    background-color: #c56a35;
    transform: translateY(-2px);
    box-shadow: 0 6px 28px rgba(232, 133, 74, 0.45);
  }

  &:active {
    transform: translateY(-1px);
  }

  &:disabled {
    opacity: 0.6;
    cursor: not-allowed;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 52px;
    border-radius: 26px;
    padding: 0 24px;
    min-width: auto;
  }

  @media (max-width: 480px) {
    height: 50px;
    border-radius: 25px;
    padding: 0 20px;
    font-size: 16px;
  }
`;

export const PrivacyNotice = styled.p`
  font-family: 'DM Sans', system-ui, sans-serif;
  font-size: 14px;
  font-weight: 400;
  line-height: 1.5;
  color: #8a8a80;
  margin: 8px 0 0;
  text-align: center;

  @media (max-width: 480px) {
    font-size: 13px;
  }
`;

export const PrivacyLink = styled.a`
  color: #e8854a;
  text-decoration: none;
  font-weight: 500;
  transition: all 0.2s ease;

  &:hover {
    color: #c56a35;
    text-decoration: underline;
  }

  &:focus {
    outline: 2px solid #e8854a;
    outline-offset: 2px;
  }
`;

// Footer Divider
export const FooterDivider = styled.hr`
  border: none;
  height: 1px;
  background: linear-gradient(90deg, transparent, rgba(0, 0, 0, 0.08), transparent);
  margin: 0;
`;

// Footer Bottom
export const FooterBottom = styled.div`
  padding: 32px 0;

  @media (max-width: 768px) {
    padding: 24px 0;
  }
`;

export const FooterBottomContent = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 32px;

  @media (max-width: 768px) {
    flex-direction: column;
    gap: 24px;
    text-align: center;
  }

  @media (max-width: 480px) {
    gap: 20px;
  }
`;

// Brand Section
export const BrandSection = styled.div`
  display: flex;
  align-items: center;
`;

export const Logo = styled.img`
  height: 48px;
  width: auto;
  transition: transform 0.2s ease;

  &:hover {
    transform: scale(1.05);
  }

  @media (max-width: 768px) {
    height: 44px;
  }

  @media (max-width: 480px) {
    height: 40px;
  }
`;

// Navigation
export const FooterNav = styled.nav`
  display: flex;
  align-items: center;
  gap: 32px;

  @media (max-width: 768px) {
    flex-wrap: wrap;
    justify-content: center;
    gap: 24px;
  }

  @media (max-width: 480px) {
    gap: 20px;
  }
`;

export const FooterNavLink = styled.a`
  color: #1a1a18;
  font-family: 'DM Sans', system-ui, sans-serif;
  font-size: 16px;
  font-weight: 400;
  text-decoration: none;
  transition: all 0.2s ease;
  position: relative;

  &::after {
    content: '';
    position: absolute;
    bottom: -4px;
    left: 0;
    width: 0;
    height: 2px;
    background-color: #e8854a;
    transition: width 0.3s ease;
  }

  &:hover {
    color: #e8854a;

    &::after {
      width: 100%;
    }
  }

  &:focus {
    outline: 2px solid #e8854a;
    outline-offset: 4px;
  }

  @media (max-width: 768px) {
    font-size: 15px;
  }

  @media (max-width: 480px) {
    font-size: 14px;
  }
`;

// Social Links
export const SocialLinks = styled.div`
  display: flex;
  align-items: center;
  gap: 16px;

  @media (max-width: 768px) {
    justify-content: center;
  }

  @media (max-width: 480px) {
    gap: 12px;
  }
`;

export const SocialLink = styled.a`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 48px;
  height: 48px;
  border-radius: 50%;
  background-color: rgba(0, 0, 0, 0.05);
  color: #1a1a18;
  text-decoration: none;
  transition: all 0.3s ease;

  &:hover {
    background-color: #e8854a;
    color: #ffffff;
    transform: translateY(-2px) scale(1.05);
    box-shadow: 0 8px 24px rgba(232, 133, 74, 0.3);
  }

  &:focus {
    outline: 2px solid #e8854a;
    outline-offset: 2px;
  }

  @media (max-width: 768px) {
    width: 44px;
    height: 44px;
  }

  @media (max-width: 480px) {
    width: 40px;
    height: 40px;
  }
`;

export const SocialIcon = styled.svg`
  width: 20px;
  height: 20px;
  transition: transform 0.2s ease;

  @media (max-width: 768px) {
    width: 18px;
    height: 18px;
  }

  @media (max-width: 480px) {
    width: 16px;
    height: 16px;
  }
`;

// Hidden elements for Mailchimp (keeping for compatibility)
export const HiddenInput = styled.input`
  position: absolute;
  left: -5000px;
  opacity: 0;
  pointer-events: none;
`;

export const HiddenDiv = styled.div`
  display: none;
`;
